<div class="container-fluid">
    <div class="row">
        <div class="col-md-3">
            <a routerLink="/naac/ssr" *ngIf="showSideMenu"> <i class="fas fa-long-arrow-alt-left"></i> Go Back</a>
            <nav id="secondary-navigation" *ngIf="showSideMenu">
                <!-- Header -->
                <header class="header">
                    <h5>CRITERIA 6</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <li routerLinkActive="active">
                        <a  routerLink="/naac/ssr/criteria6/6-1" (click)="checkRoute()">6.1</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/naac/ssr/criteria6/6-2" (click)="checkRoute()">6.2</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/naac/ssr/criteria6/6-3" (click)="checkRoute()">6.3</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/naac/ssr/criteria6/6-4" (click)="checkRoute()">6.4</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/naac/ssr/criteria6/6-5" (click)="checkRoute()">6.5</a>
                    </li>
                </ul>
            </nav>
        </div>
        <div class="col-md-9" *ngIf="showHeading">
            <h4 class="text-center"> Governance,Leadership & Management</h4>
        </div>
        <div [ngClass]="fullWidth ? 'col-md-12' : 'col-md-9'">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>